import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Typography,
  IconButton,
  Button,
  Chip,
  TablePagination,
  styled,
  tableCellClasses,
  Box,
  TextField,
} from "@mui/material";
import {
  Edit,
  Delete,
  Visibility,
  FilterList,
  Add,
  Search,
  RestartAlt,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { errorNotify } from "../../../Components/ToastComponent/ToastNotification";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: `#2C5F8E`,
    color: `#FFFFFF`,
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: "nowrap",
    fontFamily: "Geist, sans-serif",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Geist, sans-serif",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: `#EBF2FF`,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#D6E6F2",
    boxShadow: "0px 0px 5px 0px grey",
  },
}));

// const jobData = [
//   {
//     id: 1,
//     profession: "Registered Nurse",
//     country: "Qatar",
//     qualification: "B.Sc Nursing",
//     status: "Selected For Interview",
//   },
//   {
//     id: 2,
//     profession: "General Physician",
//     country: "Saudi Arabia",
//     qualification: "MBBS",
//     status: "Offer Letter accepted",
//   },

// ];

const Interview = ({ candidateID = "", candidateIDOriginal, callInterview }) => {
  const [filters, setFilters] = useState({
    profession: "",
    country: "",
    qualification: "",
    status: "",
  });

  const [jobData, setJobData] = useState([]);

  const getData = () => {
    axiosAPI
      ?.get(`/Candidate/Interview/${candidateID}`)
      .then((res) => {
        setJobData(res?.data?.data);
      })
      .catch((err) => {
        errorNotify(`Something went wrong`);
      });
  };


  useEffect(() => {
    getData();
  }, [candidateID,callInterview]);

  return (
    <>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        >
          Interview
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer
        sx={{
          border: "1px solid lightgray",
          borderRadius: "10px",
          maxWidth: "100vw",
          overflowX: "auto",
          margin: "auto",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ width:"50px" }}>#</StyledTableCell>
              <StyledTableCell>Job ID</StyledTableCell>
              <StyledTableCell>Job Title</StyledTableCell>
              <StyledTableCell>Interview Status</StyledTableCell>
              {/* {hasJobViewprivilege(privilegeData) && 
              <StyledTableCell align="center">Actions</StyledTableCell>
              } */}
            </TableRow>
          </TableHead>
          <TableBody>
            {jobData && jobData?.length > 0 ? (
              jobData
                .map((parent, index) => (
                  <StyledTableRow key={parent.id}>
                    <StyledTableCell
                      sx={{ fontSize: { xs: "12px", sm: "14px" } }}
                    >
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: { xs: "12px", sm: "14px" },
                          fontFamily: "Geist, sans-serif",
                        }}
                      >
                        {parent?.JD_JobId}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: { xs: "12px", sm: "14px" },
                          fontFamily: "Geist, sans-serif",
                        }}
                      >
                        {parent?.JD_Title}
                      </Typography>
                    </StyledTableCell>

                    {/* Status Column - Centered */}
                    <StyledTableCell>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: { xs: "12px", sm: "14px" },
                          fontFamily: "Geist, sans-serif",
                        }}
                      >
                        {parent?.JASL_Name}
                      </Typography>
                    </StyledTableCell>

                    {/* Actions Column - Right Aligned */}
                    {/* {hasJobViewprivilege(privilegeData) && (
                      <StyledTableCell align="center">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            const encrypted = encodeURIComponent(
                              encryptId(parent?.JA_JobId)
                            );
                            const url = `#/Jobs/View/${encrypted}`;
                            window.open(url, "_blank"); // Open in new tab
                          }}
                        >
                          <Visibility />
                        </IconButton>
                      </StyledTableCell>
                    )} */}
                  </StyledTableRow>
                ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={9} align="center">
                  <Typography
                    variant="body2"
                    sx={{
                      py: 2,
                      fontSize: "20px",
                      fontFamily: "Geist, sans-serif",
                    }}
                  >
                    No data available
                  </Typography>
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Interview;
